<template>
  <div class="home-section-state home-section-state--error" role="status">
    <p>{{ message }}</p>
    <button v-if="retryable" type="button" class="home-state-retry" @click="$emit('retry')">Tentar novamente</button>
  </div>
</template>

<script>
export default {
  name: "HomeSectionError",
  props: {
    message: { type: String, default: "Nao foi possivel carregar esta secao." },
    retryable: { type: Boolean, default: true },
  },
};
</script>
